import { Component } from '@angular/core';
import { ErrorPageComponent } from '../error-page/error-page.component';

@Component({
    selector: 'app-error-401',
    standalone: true,
    imports: [ErrorPageComponent],
    templateUrl: './error-401.component.html'
})
export class Error401Component {

}
